import { Component, OnInit } from '@angular/core';
import { VillageService } from 'src/app/services/village.service';
import {ThemePalette} from '@angular/material/core';
import { FormGroup, FormControl, Validators, AbstractControl } from '@angular/forms';
import { MainGatesComponent } from '../main-gates/main-gates.component';
import { MatDialogRef } from '@angular/material/dialog';
import { UnitsService } from 'src/app/services/units.service';

@Component({
  selector: 'app-add-user-config',
  templateUrl: './add-user-config.component.html',
  styleUrls: ['./add-user-config.component.css']
})
export class AddUserConfigComponent implements OnInit {


  
  village_list:any
  color: ThemePalette = "primary";
  checked = false;
  Village_form :FormGroup | any;
  types_arr:any

  constructor(private villageSer : VillageService , 
    private unitServ : UnitsService,
     public dialogRef: MatDialogRef<MainGatesComponent>,){}

  ngOnInit(){
    this.allVillage()
    this.initForm()
    this.users_type()
  }
  initForm(){
    this.Village_form = new FormGroup({
      villages: new FormControl("", [Validators.required]),
      user_type: new FormControl("" ,[Validators.required]),
      anti_passback: new FormControl(""),
      vip_access: new FormControl(""),
      applying_quota: new FormControl(""),
      owner_existence: new FormControl(""),
    })
  }

  users_type(){
    this.unitServ.unitRelation().subscribe((res: any) => {
      console.log(res)
      this.types_arr = res.children
    })
  }

  allVillage(){
    this.villageSer.villageList().subscribe((res:any) => {
      console.log(res)
      this.village_list = res
    })
  }
  add_user_config(){
    let data = this.Village_form.value
    console.log(data)
     this.dialogRef.close(data)
  }
}
